export default __webpack_public_path__ + "static/media/carrot.93433cfc.svg";